module.exports = __webpack_public_path__ + "static/media/home_start_video.50c5afd1.mp4";